define("shared/components/shared/post/profile-selector/unavailable-profile/index", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless @state.isAvailable}}
    <li class="cCP--list__item--disabled">
      <Shared::ProfileAvatar
        @showDetails={{true}}
        @showOutline={{true}}
        @showPlatform={{true}}
        @socialProfile={{@profile}}
        class="cCA--user is--unselected u--mute cCP--list__col--left"
      />
      <div class="cCP--list__col--right qa--modal_validation_error">
        {{#if (eq @state.state "twitterSunset")}}
          {{t "twitter-deprecation.alert_banner.message_rollout"}}
        {{else if (eq @state.state "pastPostLimit")}}
          <span>
            {{t (concat "post.copy_post.modal.unavailable." @state.state) socialPlatform=@profile.accountType}}
          </span>
          <Shared::Button::Upgrade
            @additionalAction={{@closeAction}}
            @confirmCopy={{this.confirmUpgradeCopy}}
            @confirmLeave={{true}}
            @feature="getMorePosts"
            @text={{t "post.copy_post.modal.unavailable.upgrade"}}
            @variant="actionLink"
            class="u--text--success"
          />
        {{else}}
          {{t
            (concat "post.copy_post.modal.unavailable." @state.state)
            mediaType=(t (concat "shared_phrases.posts." @state.unsupportedMedia))
            socialPlatform=@profile.accountType
          }}
        {{/if}}
      </div>
    </li>
  {{/unless}}
  */
  {
    "id": "xtXSvsc9",
    "block": "[[[41,[51,[30,1,[\"isAvailable\"]]],[[[1,\"  \"],[10,\"li\"],[14,0,\"cCP--list__item--disabled\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"cCA--user is--unselected u--mute cCP--list__col--left\"]],[[\"@showDetails\",\"@showOutline\",\"@showPlatform\",\"@socialProfile\"],[true,true,true,[30,2]]],null],[1,\"\\n    \"],[10,0],[14,0,\"cCP--list__col--right qa--modal_validation_error\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,1,[\"state\"]],\"twitterSunset\"],null],[[[1,\"        \"],[1,[28,[35,4],[\"twitter-deprecation.alert_banner.message_rollout\"],null]],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,1,[\"state\"]],\"pastPostLimit\"],null],[[[1,\"        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,4],[[28,[37,5],[\"post.copy_post.modal.unavailable.\",[30,1,[\"state\"]]],null]],[[\"socialPlatform\"],[[30,2,[\"accountType\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,6],[[24,0,\"u--text--success\"]],[[\"@additionalAction\",\"@confirmCopy\",\"@confirmLeave\",\"@feature\",\"@text\",\"@variant\"],[[30,3],[30,0,[\"confirmUpgradeCopy\"]],true,\"getMorePosts\",[28,[37,4],[\"post.copy_post.modal.unavailable.upgrade\"],null],\"actionLink\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,4],[[28,[37,5],[\"post.copy_post.modal.unavailable.\",[30,1,[\"state\"]]],null]],[[\"mediaType\",\"socialPlatform\"],[[28,[37,4],[[28,[37,5],[\"shared_phrases.posts.\",[30,1,[\"unsupportedMedia\"]]],null]],null],[30,2,[\"accountType\"]]]]]],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@state\",\"@profile\",\"@closeAction\"],false,[\"unless\",\"shared/profile-avatar\",\"if\",\"eq\",\"t\",\"concat\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/post/profile-selector/unavailable-profile/index.hbs",
    "isStrictMode": false
  });
  let UnavailableProfileComponent = _exports.default = (_class = class UnavailableProfileComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get confirmUpgradeCopy() {
      return {
        title: this.intl.t('post.copy_post.confirm_upgrade.title'),
        args: {
          description: this.intl.t('post.copy_post.confirm_upgrade.description'),
          confirmButton: this.intl.t('post.copy_post.confirm_upgrade.confirm')
        }
      };
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UnavailableProfileComponent);
});